function isWeakSet(value) {
    return value instanceof WeakSet;
}

export { isWeakSet };
